import { render, staticRenderFns } from "./ModuleNftManager.vue?vue&type=template&id=62959b94&scoped=true"
import script from "./ModuleNftManager.vue?vue&type=script&lang=js"
export * from "./ModuleNftManager.vue?vue&type=script&lang=js"
import style1 from "./ModuleNftManager.vue?vue&type=style&index=1&id=62959b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62959b94",
  null
  
)

export default component.exports